import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CourseDateFormDialog = ({ open, onClose, courseDate, courses, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    course_id: '', date: '', time: '09:30', location: 'Bautzner Str. 23, 01099 Dresden', max_participants: 20, price: null
  });

  useEffect(() => {
    if (courseDate) {
      const dateObj = new Date(courseDate.date);
      setFormData({
        course_id: courseDate.course_id, date: dateObj.toISOString().split('T')[0], time: courseDate.time || '09:30',
        location: courseDate.location || 'Bautzner Str. 23, 01099 Dresden', max_participants: courseDate.max_participants || 20, price: courseDate.price || null
      });
    } else {
      setFormData({ course_id: '', date: '', time: '09:30', location: 'Bautzner Str. 23, 01099 Dresden', max_participants: 20, price: null });
    }
  }, [courseDate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        course_id: formData.course_id, date: formData.date, time: formData.time, location: formData.location,
        max_participants: parseInt(formData.max_participants), price: formData.price ? parseFloat(formData.price) : null
      };
      if (courseDate) {
        await axios.put(`${BACKEND_URL}/admin/course-dates/${courseDate.id}`, data);
      } else {
        await axios.post(`${BACKEND_URL}/admin/course-dates`, data);
      }
      onSuccess();
      onClose();
    } catch (error) {
      alert('Fehler beim Speichern des Termins.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>{courseDate ? 'Termin bearbeiten' : 'Neuer Termin'}</DialogTitle></DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="course_id">Kurs *</Label>
            <select id="course_id" name="course_id" value={formData.course_id} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4AF37]">
              <option value="">Kurs auswählen...</option>
              {courses.map(course => (<option key={course.id} value={course.id}>{course.title}</option>))}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="date">Datum *</Label>
              <Input id="date" name="date" type="date" value={formData.date} onChange={handleChange} required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="time">Uhrzeit *</Label>
              <Input id="time" name="time" type="time" value={formData.time} onChange={handleChange} required />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="location">Ort *</Label>
            <Input id="location" name="location" value={formData.location} onChange={handleChange} required />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="max_participants">Max. Teilnehmer *</Label>
              <Input id="max_participants" name="max_participants" type="number" value={formData.max_participants} onChange={handleChange} required min="1" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="price">Preis (EUR, optional)</Label>
              <Input id="price" name="price" type="number" step="0.01" value={formData.price || ''} onChange={handleChange} placeholder="Standard-Kurspreis" />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Abbrechen</Button>
            <Button type="submit" disabled={loading}>{loading ? 'Speichert...' : courseDate ? 'Aktualisieren' : 'Erstellen'}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
